import { useMemo } from 'react';

import { useGetStoreAvailabilityFn, useIsMobileOrderingAvailable } from 'features/store/hooks';
import { useOpenClosedText } from 'features/store/pages/store-locator-experiment/components/store-card/hooks/use-open-closed-text';
import { useIntl } from 'react-intl';

import { IRestaurant } from '@rbi-ctg/store';

interface UseErrorMessageOptions {
  restaurant: IRestaurant;
}

export const useErrorMessage = ({ restaurant }: UseErrorMessageOptions) => {
  const { formatMessage } = useIntl();
  const { isOpen } = useOpenClosedText(restaurant);

  const getRestaurantAvailability = useGetStoreAvailabilityFn();
  const isMobileOrderingAvailable = useIsMobileOrderingAvailable(restaurant);

  const isRestaurantAvailable = getRestaurantAvailability(restaurant);

  return useMemo(() => {
    if (!restaurant.hasMobileOrdering) {
      return formatMessage({ id: 'mobileOrderingUnavailableAtStore' });
    } else if (!isMobileOrderingAvailable || !isRestaurantAvailable || !isOpen) {
      return formatMessage({ id: 'mobileOrderingUnavailable' });
    }

    return;
  }, [
    formatMessage,
    isMobileOrderingAvailable,
    isOpen,
    isRestaurantAvailable,
    restaurant.hasMobileOrdering,
  ]);
};
